import { KeyValue } from "@/main/models/common";
import { ModelRequest } from "@/main/models/request";
import { ModelTypes, ModelActionTypes } from "./modelTypes";

export function getModels(request: ModelRequest, keyReducer: string = "default"): ModelActionTypes {
	return {
		type: ModelTypes.GET_MODELS,
		payload: { request, keyReducer },
	};
}

export function saveModels(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
	keyReducer: string = "default",
): ModelActionTypes {
	return {
		type: ModelTypes.SAVE_MODELS,
		payload: { data, isError, errorMessages, keyReducer },
	};
}

export function resetReducerModels(keyReducer: string = "default"): ModelActionTypes {
	return {
		type: ModelTypes.RESET_REDUCER_MODELS,
		payload: { keyReducer },
	};
}
